import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Checkbox, Form, Input, Modal, Pagination, Space } from "antd";

import partnersApi from "../../apis/Partners.api";
import PartnersApi from "../../apis/Partners.api";
import BoardChannelComment from "../../components/channel/BoardChannelComment";
import { setLoading } from "../../redux/store/common/commonDuck";

const Board = ({ channelInfo }) => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const history = useHistory();
	const dispatch = useDispatch();
	// const location = useLocation();

	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));
	const pageSize = 3;
	const [offset, setOffset] = useState(0);
	const [allCount, setAllCount] = useState(0);
	const [currentPageNumber, setCurrentPageNumber] = useState(1);

	const [myShow, setMyShow] = useState(false);
	const [commentModalShow, setCommentModalShow] = useState(false);
	const [findMine, setFindMine] = useState({
		phoneCenter: "",
		password: "",
	});
	const [showMine, setShowMine] = useState(false);
	const [findMineValid, setFindMineValid] = useState({
		phoneCenter: true,
		password: true,
	});
	const [commentValue, setCommentValue] = useState({
		phone: "",
		password: "",
		comment: "",
		is_secret: false,
	});
	const [commentValid, setCommentValid] = useState({
		phone: true,
		password: true,
		comment: true,
	});

	const [commentList, setCommentList] = useState([]);

	useEffect(() => {
		getInfo(offset);
	}, [offset]);

	const getInfo = async (offset) => {
		let param = {
			query: channelInfo?.influencer_id,
			offset: offset,
			pageSize: 3,
		};
		const res = await PartnersApi.getChannel(param);
		if (res.code === 200) {
			setCommentList(res.result?.commentList);
		}
	};

	useEffect(() => {
		if (!channelInfo) {
			history.goBack();
		}
		setCommentList(channelInfo?.commentList);
		setAllCount(channelInfo?.totalCnt);
		if (channelInfo.id) {
			updateCount();
		}
	}, [history, channelInfo]);

	const updateCount = async () => {
		await partnersApi.updateVisitorCount(channelInfo);
		// console.log(res);
	};

	/**
	 * 댓글쓰기 버튼 클릭
	 */
	const handleCommentButton = () => {
		setCommentModalShow(true);
		setCommentValue({
			phone: "",
			password: "",
			comment: "",
			is_secret: false,
		});
		setCommentValid({
			phone: true,
			password: true,
			comment: true,
		});
	};

	/**
	 * 댓글 작성 내용 state 저장
	 * @param e
	 */
	const handleComment = (e) => {
		setCommentValue({
			...commentValue,
			[e.target.name]: e.target.value,
		});
	};

	/**
	 * 댓글쓰기 -> 작성 완료
	 * @returns {Promise<void>}
	 */
	const submitCreateComment = async () => {
		let newValid = { ...commentValid };
		let regPhone = /010-?([0-9]{4})-?([0-9]{4})$/;
		let regPassword = /([0-9]{4})$/;

		if (!regPhone.test(commentValue.phone)) {
			newValid = {
				...newValid,
				phone: false,
			};
		} else {
			newValid = {
				...newValid,
				phone: true,
			};
		}

		if (
			!regPassword.test(commentValue.password) ||
			commentValue.password.length > 4
		) {
			newValid = {
				...newValid,
				password: false,
			};
		} else {
			newValid = {
				...newValid,
				password: true,
			};
		}

		if (
			!commentValue.comment ||
			commentValue.comment?.length === 0 ||
			commentValue.comment?.length > 500
		) {
			newValid = {
				...newValid,
				comment: false,
			};
		} else {
			newValid = {
				...newValid,
				comment: true,
			};
		}
		setCommentValid(newValid);

		if (!Object.values(newValid).includes(false)) {
			setIsLoading(true);
			let param = {
				influencer_id: reduxChannel?.user_id,
				board_id: channelInfo.id,
				phone: commentValue.phone,
				password: commentValue.password,
				content: commentValue.comment,
				is_secret: commentValue.is_secret,
			};
			const res = await partnersApi.createComment(param);
			if (res.code === 200) {
				getInfo(0);
				setCurrentPageNumber(1);
				setCommentModalShow(false);
				setIsLoading(false);
			} else {
				setIsLoading(false);
			}
		}
	};

	const handleMine = () => {
		if (showMine) {
			setCommentList(channelInfo?.commentList);
			setShowMine(false);
		} else {
			setMyShow(true);
		}
	};

	/**
	 * 내가 쓴 글 찾기
	 * @returns {Promise<void>}
	 */
	const handleMyComment = async () => {
		setIsLoading(true);
		if (!showMine) {
			let param = {
				boardId: channelInfo.id,
				phoneCenter: findMine.phoneCenter,
				password: findMine.password,
			};
			const res = await partnersApi.readByCustomer(param);
			if (res.code === 200) {
				if (res.result.length === 0) {
					setFindMineValid({
						phoneCenter: false,
						password: false,
					});
				} else {
					setFindMineValid({
						phoneCenter: true,
						password: true,
					});
					setCommentList(res.result);
					setMyShow(false);
					setShowMine(true);
				}
			}
		}
		setIsLoading(false);
	};

	/**
	 * page 넘김
	 */
	const handleChangePagination = (pageNumber) => {
		const currOffset = (pageNumber - 1) * pageSize;
		setCurrentPageNumber(pageNumber);
		setOffset(currOffset);
	};

	return (
		<div className="main-wrap channel-wrap">
			<div className={`channel-contents`}>
				{/*<div className={`channel-head`}>*/}
				{/*    <img*/}
				{/*        src={`${process.env.REACT_APP_S3_HOST}/image/together/profile_${channelInfo?.id}.${channelInfo?.profile_img_type}`}*/}
				{/*        // src={`/assets/images/channel/doctor.png`}*/}
				{/*        className={`channel-img`}*/}
				{/*        onError={({currentTarget}) => {*/}
				{/*            currentTarget.onerror = null; // prevents looping*/}
				{/*            // currentTarget.style.display = "none";*/}
				{/*            currentTarget.src = `/assets/images/channel/basic.png`;*/}
				{/*        }}*/}
				{/*        alt={`채널 이미지`}*/}
				{/*    />*/}
				{/*    <h2 className={`channel-title`}>*/}
				{/*        {channelInfo?.nickname ?? "채널명"}*/}
				{/*    </h2>*/}
				{/*</div>*/}
				<div className={`channel-body`}>
					{/*<h3 className={`body-title`}>*/}
					{/*    ✅ {channelInfo?.title}*/}
					{/*</h3>*/}
					<div className={`body-contents`}>
						<p
							dangerouslySetInnerHTML={{
								__html: channelInfo?.content,
							}}
						/>
						{/*{contentList.map((item, idx) => (*/}
						{/*    <div key={`상품 추천 내역 ${idx}`}>*/}
						{/*        <p className={`contents-title`}>*/}
						{/*            {item.title}*/}
						{/*        </p>*/}
						{/*        <p>*/}
						{/*            {item.body}*/}
						{/*        </p>*/}
						{/*        <Link to={item.link}>*/}
						{/*            {item.link}*/}
						{/*        </Link>*/}
						{/*    </div>*/}
						{/*))}*/}
						<span
							className={`commission-notice`}
							style={{ whiteSpace: "pre-wrap" }}
						>
							이 포스팅은 아이허브, 당영투게더 활동의 일환으로, 이에 따른
							일정액의 수수료를 제공받습니다.
						</span>
					</div>
				</div>
				{channelInfo?.register_comment && (
					<div className={`channel-footer`}>
						<div className={`body-comment`}>
							<Space direction={`vertical`}>
								<span>
									댓글
									<span className={`comment-count`}>
										{channelInfo?.totalCnt}
									</span>
								</span>
								<Button
									size={`small`}
									className={`${showMine ? "edit-success-btn" : ""}`}
									onClick={handleMine}
								>
									내가 쓴 글 찾기
								</Button>
							</Space>
							<Button
								size={`small`}
								id={`write-comment`}
								onClick={handleCommentButton}
								style={{
									backgroundColor: "#117ffa",
								}}
							>
								<span
									style={{
										color: "white",
									}}
								>
									댓글쓰기
								</span>
							</Button>
						</div>
						{commentList?.map((item, idx) => (
							<div className={`comment-wrap`} key={`댓글 내용 ${idx}`}>
								<BoardChannelComment channelInfo={channelInfo} item={item} />
							</div>
						))}
						{!showMine && (
							<Pagination
								className="report-pagination-wrap channel-pagination"
								showSizeChanger={false}
								current={currentPageNumber}
								pageSize={pageSize}
								total={allCount}
								onChange={handleChangePagination}
							/>
						)}
					</div>
				)}
			</div>
			<div className={`channel-notice`}>
				<div className={`channel-head`}>
					<p className={`channel-title`} style={{ fontSize: "1.4em" }}>
						{channelInfo?.notice?.title}
					</p>
				</div>
				<div className={`channel-body`}>
					<div className={`body-contents`}>
						<p>{channelInfo?.notice?.content}</p>
					</div>
				</div>
			</div>

			{/* 내가 쓴 글 찾기 */}
			<Modal
				title="내가 쓴 글 찾기"
				wrapClassName="order-detail-modal-wrap channel-modal"
				open={myShow}
				centered={true}
				onCancel={() => setMyShow(!myShow)}
				width="25%"
				cancelText={<span>취소</span>}
				okText={<span>조회</span>}
				onOk={handleMyComment}
				confirmLoading={isLoading}
			>
				<Form layout={`vertical`}>
					<Form.Item
						label="휴대폰 번호 가운데 4자리"
						labelAlign="left"
						colon={false}
						required
					>
						<Input
							type={`text`}
							placeholder={`휴대폰 번호 가운데 4자리를 입력해주세요.`}
							required
							value={findMine.phoneCenter}
							onChange={(e) => {
								setFindMine({
									...findMine,
									phoneCenter: e.target.value,
								});
							}}
							style={
								!findMineValid.phoneCenter ? { borderColor: "#fe2b4b" } : {}
							}
						/>
					</Form.Item>
					<Form.Item
						label="비밀번호 4자리"
						labelAlign="left"
						colon={false}
						required
					>
						<Input
							type={`text`}
							placeholder={`비밀번호를 입력해주세요.`}
							required
							value={findMine.password}
							onChange={(e) => {
								setFindMine({
									...findMine,
									password: e.target.value,
								});
							}}
							style={!findMineValid.password ? { borderColor: "#fe2b4b" } : {}}
						/>
					</Form.Item>
				</Form>
			</Modal>

			{/* 댓글쓰기 */}
			<Modal
				title="댓글쓰기"
				wrapClassName="order-detail-modal-wrap"
				// channel-modal
				open={commentModalShow}
				centered={true}
				onCancel={() => setCommentModalShow(!commentModalShow)}
				width="40%"
				cancelText={<span>취소</span>}
				okText={<span style={{ color: "white" }}>작성 완료</span>}
				onOk={submitCreateComment}
				confirmLoading={isLoading}
			>
				<Form>
					<Form.Item
						label="휴대폰 번호"
						labelAlign="left"
						colon={false}
						labelCol={{ span: 5 }}
						required
					>
						<Input
							type={`text`}
							placeholder={`- 없이 입력해주세요.`}
							value={commentValue.phone}
							name={"phone"}
							onChange={handleComment}
							style={
								!commentValid.phone
									? {
											borderColor: "#fe2b4b",
									  }
									: {}
							}
						/>
						<span className={`created_at`} style={{ fontSize: "0.9em" }}>
							ex) 01012345678
						</span>
					</Form.Item>
					<Form.Item
						label="비밀번호"
						labelAlign="left"
						colon={false}
						required
						labelCol={{ span: 5 }}
					>
						<Input
							type={`text`}
							placeholder={`비밀번호 4자리를 입력해주세요.`}
							value={commentValue.password}
							name={"password"}
							onChange={handleComment}
							style={
								!commentValid.password
									? {
											borderColor: "#fe2b4b",
									  }
									: {}
							}
						/>
						<div style={{ display: "flex", flexDirection: "column" }}>
							<span className={`created_at`} style={{ fontSize: "0.9em" }}>
								ex) 1234
							</span>
							<span className={`write-password`}>
								* 비밀번호는 다시 찾을 수 없으니 주의해주세요.{"\n"}* 작성된
								글은 모두 비밀글로 작성됩니다. 조회 시 비밀번호가 필요합니다.
							</span>
						</div>
					</Form.Item>
					<Form.Item
						label="댓글 내용"
						labelAlign="left"
						colon={false}
						labelCol={{ span: 5 }}
						required
						className={`write-textarea`}
					>
						<Input.TextArea
							placeholder={`댓글 내용을 입력해주세요. (최대 500자)\n* 비방, 욕설 등 부적절한 내용 입력 시 삭제될 수 있습니다.\n* 작성 된 글은 모두 비밀글로 작성됩니다.`}
							value={commentValue.comment}
							name={"comment"}
							onChange={handleComment}
							style={!commentValid.comment ? { borderColor: "#fe2b4b" } : {}}
						/>
						<div
							style={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
							}}
						>
							<Checkbox
								onChange={(e) =>
									setCommentValue({
										...commentValue,
										is_secret: e.target.checked,
									})
								}
								value={commentValue.is_secret}
								checked={commentValue.is_secret}
								style={{
									paddingTop: "0.5em",
								}}
							>
								{/*비밀글로 작성하기*/}
								비밀글
							</Checkbox>
							<span className={`created_at`} style={{ textAlign: "right" }}>
								{commentValue.comment.length} / 500
							</span>
						</div>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	);
};
export default Board;
